export class Core {
  public values: Values = new Values();
  public checks: Checks = new Checks();
}

export class Values {}

export class Checks {}
